import { isConnectedAccount } from 'owa-accounts-store';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { CalendarEvent } from 'owa-calendar-types';
import {
    isOnGroupCalendar,
    isMeetingOnCalendarSharedWithMe,
} from 'owa-calendar-event-capabilities';
import { FilterableMenuItem } from 'owa-filterable-menu';
import {
    default as convertAddinToFilterableMenuItem,
    AddinCount,
} from './convertAddinToFilterableMenuItem';
import {
    lazyAddinCommandSurfaceItemsObserver,
    getComposeHostItemIndex,
    getReadHostItemIndex,
} from 'owa-addins-core';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    CalendarSurfaceAddinsOptions,
} from 'owa-outlook-service-options';

let styles = require('./commandBarAddins.scss');

export default function (
    extMode: ExtensibilityModeEnum,
    event: CalendarEvent,
    hostId: string,
    disabled?: boolean
) {
    let items: FilterableMenuItem[] = [];

    if (
        isOnGroupCalendar(event) ||
        (event.ParentFolderId?.mailboxInfo &&
            isConnectedAccount(event.ParentFolderId.mailboxInfo.userIdentity))
    ) {
        // Add-ins are not supported on group calendars, or for connected account
        return items;
    }

    const addinCollectionGetter = lazyAddinCommandSurfaceItemsObserver.tryImportForRender();

    // Check if the getter is imported. If it isn't we'll return an empty array for now.
    // When the import succeeds, this will re-run since it's called from render.
    if (addinCollectionGetter) {
        const isSharedItem = isMeetingOnCalendarSharedWithMe(event);
        const hostItemIndex =
            extMode == ExtensibilityModeEnum.AppointmentAttendee
                ? getReadHostItemIndex(hostId)
                : getComposeHostItemIndex(hostId);
        const addinCollection = addinCollectionGetter(extMode, isSharedItem, hostItemIndex).get();
        if (addinCollection) {
            const installedAddins = addinCollection.sectionProps.items;
            let addinCount: AddinCount = {
                overflow: 0,
            };
            const calendarSurfaceAddinsOptions = getOptionsForFeature<CalendarSurfaceAddinsOptions>(
                OwsOptionsFeatureType.CalendarSurfaceAddins
            );

            // For each each addin, convert it to a FilterableMenuItem, and push it to the collection.
            installedAddins.forEach(addin => {
                let filterableMenuItem = convertAddinToFilterableMenuItem(
                    addin,
                    calendarSurfaceAddinsOptions.calendarSurfaceAddins,
                    hostItemIndex,
                    styles.commandBarAddin,
                    addinCount,
                    disabled
                );

                // The converter can return null if we shouldn't include this addin for various reasons.
                if (filterableMenuItem) {
                    items.push(filterableMenuItem);
                }
            });
        }
    }
    return items;
}
